import React from 'react'

const PageNotFound = () => {
    return (
        <>

           
            {/* REGISTER */}
            <section>
                <div className="login pg-404">
                    <div className="container">
                        <div className="row">
                            <div className="inn">
                                <div className="lhs">
                                    <div className="tit">
                                        <h2>
                                            Page not found <b>404</b>
                                        </h2>
                                        <h5>We can't seem to find the page you are looking for.</h5>
                                        <a href="/" className="cta-4">
                                            Visit home page now
                                        </a>
                                    </div>
                                    <div className="log-bg">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
  
        
        </>

    )
}

export default PageNotFound